import { atom } from "recoil";

export const tgBotsEditModalStore = atom({
	key: "tgBotsEditModalStore",
	default: {
		show: false,
		loaded: true,
		id: 0,
		currentOption: {
			status: [
				{ value: "free", label: "free" },
				{ value: "disabled", label: "disabled" },
				{ value: "current", label: "current" },
			],
		},
		bot_link: "",
		status: { value: "free", label: "free" },
		priority: "",
		token: "",
	},
});
